<template>
    <div class="score-circle-wrapper">
  
      <div class="circle-container">
  
        <svg
          viewBox="0 0 120 120"
          class="circle-svg"
        >
  
          <circle
            cx="60"
            cy="60"
            r="50"
            class="circle-bg"
          />
  
          <circle
            cx="60"
            cy="60"
            r="50"
            class="circle-progress"
            :style="{
              strokeDashoffset: dashOffset
            }"
          />
  
        </svg>
  
  
        <div class="circle-content">
  
          <strong>
            {{ value }}%
          </strong>
  
          <span>
            {{ title }}
          </span>
  
        </div>
  
      </div>
  
    </div>
  </template>
  
  
  <script setup>
  
  const props = defineProps({
  
    value: {
      type: Number,
      default: 0
    },
  
    title: {
      type: String,
      default: ""
    }
  
  });
  
  
  const circumference = 314;
  
  
  const dashOffset = 
    circumference -
    (
      circumference *
      props.value /
      100
    );
  
  </script>
  
  
  <style scoped>
  
  .score-circle-wrapper {
  
    display:flex;
    justify-content:center;
    align-items:center;
  
  }
  
  
  .circle-container {
  
    position:relative;
  
    width:92px;
    height:92px;
  
  }
  
  
  .circle-svg {
  
    width:100%;
    height:100%;
  
    transform:rotate(-90deg);
  
  }
  
  
  .circle-bg {
  
    fill:none;
  
    stroke:
      rgba(61,130,237,.12);
  
    stroke-width:9;
  
  }
  
  
  .circle-progress {
  
    fill:none;
  
    stroke:
      #4388f5;
  
    stroke-width:9;
  
    stroke-linecap:round;
  
    stroke-dasharray:314;
  
    transition:
      stroke-dashoffset .7s
      cubic-bezier(.22,1,.36,1);
  
  }
  
  
  .circle-content {
  
    position:absolute;
  
    inset:0;
  
    display:flex;
  
    flex-direction:column;
  
    align-items:center;
  
    justify-content:center;
  
  }
  
  
  .circle-content strong {
  
    color:
      var(--drawer-text);
  
    font-family:
      "Eastman-Bold",
      sans-serif;
  
    font-size:18px;
  
    line-height:1;
  
  
  }
  
  
  .circle-content span {
  
    margin-top:5px;
  
    color:
      var(--drawer-text-muted);
  
    font-family:
      "Eastman-Regular",
      sans-serif;
  
    font-size:9px;
  
  }
  
  
  </style>